/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of InventoryPurchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InventorypurchaseReturnDetailsApi } from './../../api/transaction/purchasereturndetails.api';
import { InventoryPurchaseReturnDetailsData, InventoryPurchaseReturnDetails } from './../../interface/transaction/purchasereturndetails';

@Injectable()
export class InventoryPurchaseReturnDetailsService extends InventoryPurchaseReturnDetailsData {

  constructor(private api: InventorypurchaseReturnDetailsApi) {
    super();
  }



  list(url: string): Observable<InventoryPurchaseReturnDetails[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<InventoryPurchaseReturnDetails>{
      return this.api.getById(url);
  }

  create(url: string, data:InventoryPurchaseReturnDetails): Observable<InventoryPurchaseReturnDetails> {
    return this.api.add(url,data);
  }

  update(url: string, data:InventoryPurchaseReturnDetails): Observable<InventoryPurchaseReturnDetails> {
    console.log('url', url);
    console.log('data', data);
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
